import {Injectable} from '@angular/core';
import {RosterService} from './roster.service';
import {CourseService} from './course.service';
import {CourseList} from './interface/course.interface';
import {Roster} from './interface/roster.interface';
import {GradingRuleList} from './interface/grading-rule.interface';
import {GradingRuleService} from './grading-rule.service';
import {UcrSecurityService} from "../core/ucr-security/ucr-security.service";
import {UserInfo} from "../core/ucr-security/user-info";

@Injectable()
export class CourseCacheService {
    private userInfo: UserInfo;

    constructor(
        private courseService: CourseService,
        private rosterService: RosterService,
        private gradingRuleService: GradingRuleService,
        private security: UcrSecurityService,
    ) {
        this.security.getUserInfo().subscribe((ui) => {
            this.userInfo = ui;
        });
    }

    setCache(termCode: string, crn: string = '') {
        if (!this.userInfo) {
            this.security.getUserInfo().subscribe((ui) => {
                this.userInfo = ui;
            });
        }
         if (!this.courseService.currentCourse) {
            this.courseService.getByCRN(termCode, crn).subscribe((response: CourseList) => {
                if (response.list.length > 0) {
                    let course = response.list[0];

                    if (this.userInfo) {
                        if (
                            response?.list?.find((m) => {
                                return m.instructorNetId === this.userInfo.username;
                            })
                        ) {
                            course = response?.list?.find((m) => { return m.instructorNetId === this.userInfo.username });

                        }
                    }

                    this.courseService.setCurrentCourse(course);
                }
            });
        }
        if (!this.rosterService.currentRoster) {
            this.rosterService.get(termCode, crn).subscribe((response: Roster) => {
                this.rosterService.setCurrentRoster(response);
            });
        }

        if (!this.gradingRuleService.currentValidGradeList) {
            this.gradingRuleService.get().subscribe((response: GradingRuleList) => {
                if (response.list.length > 0) {
                    this.gradingRuleService.setCurrentGradingList(response.list);
                }
            });
        }


    }
}
